/**
 * PromptEyebrow — terminal-prompt style eyebrow label.
 *
 * Renders a monospace inline-flex row with a `>` prompt, plain-English
 * label text, and an optional blinking caret. The text carries the same
 * CRT phosphor treatment (scanlines + flicker) as the TerminalWindow
 * screen, so eyebrows read as part of the same terminal.
 *
 * Props:
 *   children  — label text
 *   tone      — 'default' (blue prompt/caret) | 'purple' (purple prompt/caret)
 *   as        — element tag to render the outer wrapper (default 'span')
 *   caret     — whether to show the blinking term-caret (default true)
 *   crt       — whether to apply the .crt-text scanline/flicker (default true)
 *   className — composed onto the outer wrapper
 *
 * Uses .crt-text and .term-caret from src/styles/terminal.css.
 */
export default function PromptEyebrow({ children, tone = 'default', as: Tag = 'span', caret = true, crt = true, className = '' }) {
  const accent = tone === 'purple' ? 'text-brand-purple' : 'text-brand-blue-bright';
  return (
    <Tag
      className={`inline-flex items-baseline font-mono text-mono-md ${crt ? 'crt-text' : ''} ${className}`}
    >
      <span aria-hidden="true" className={`${accent} font-semibold mr-2`}>
        {'>'}
      </span>
      <span className="text-ink-100">{children}</span>
      {caret && <span className={`term-caret${tone === 'purple' ? ' term-caret--purple' : ''}`} aria-hidden="true" />}
    </Tag>
  );
}
